import { Outlet } from "react-router-dom";
import AdminSidebar from "components/admin/AdminSidebar";
import AdminTopbar from "components/admin/AdminTopbar";

/** Shell for every protected /admin route: fixed sidebar + sticky topbar + page. */
export default function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-[#f4f6f8] font-sans">
      <AdminSidebar />
      <div className="flex-1 ml-[248px] flex flex-col">
        <AdminTopbar />
        <div className="px-9 py-7 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
